// Building the next column-width map.
//
// ⚠ ONE MAP PER UPDATE, and the history here is worth knowing because the
// obvious fix is the one that was already tried.
//
// Persisting used to happen inside the React state updater, and a width could
// be saved that the next updater then superseded — so the fix was to move the
// save OUTSIDE the updater. That removed one race and introduced another: the
// saved map was built by spreading the RENDER-TIME `widths`, while the state
// was built by a functional updater from the current value. Resize column A,
// then column B before a re-render, and B's save is based on a map that never
// had A's new width in it. Last write wins, and A silently reverts on the next
// visit.
//
// So the rule is not "inside" or "outside" — it is that the map which goes into
// state and the map which goes into storage must be THE SAME OBJECT, built once
// from the same base.
//
// Extracted so that sequence can be tested without a pointer, a drag, or a
// render.

/** The width map with one column changed, leaving the rest alone. */
export function mergeColumnWidth(
  previous: Record<string, number>,
  column: string,
  px: number
): Record<string, number> {
  return { ...previous, [column]: px };
}
